<template>
    <v-layout>
        <v-flex xs12 class="mb-5">
          <v-container>
            <v-layout>

                <v-flex xs3 class="mb-5 mr-2">
                  <h2>Primary Button</h2>

                  <div class="bglight btncontainer">
                    <div class="btndiv"><v-btn color="primary">Button</v-btn></div>
                    <div class="btndiv"><v-btn color="primary">Active</v-btn></div>
                    <div class="btndiv"><v-btn color="primary" :disabled="disabled">Disabled</v-btn></div>
                    <div class="btndiv"><v-btn color="primary"><v-progress-circular v-if="loading" indeterminate size="22" width="3"></v-progress-circular></v-btn></div>
                    <div class="btndiv"><v-btn color="primary"><v-icon class="mr-1">add</v-icon> Button with Icon</v-btn></div>
                  </div>
                </v-flex>

                <v-flex xs6 class="mb-5 mr-4">
                  <h2>Secondary Button</h2>
                  <v-layout>
                    <v-flex xs6>
                  <div class="bglight btncontainer">
                    <div class="btndiv"><v-btn flat outline>Button</v-btn></div>
                    <div class="btndiv"><v-btn flat outline>Active</v-btn></div>
                    <div class="btndiv"><v-btn flat outline :disabled="disabled">Disabled</v-btn></div>
                    <div class="btndiv"><v-btn flat outline><v-progress-circular v-if="loading" indeterminate size="22" width="3"></v-progress-circular></v-btn></div>
                    <div class="btndiv"><v-btn flat outline><v-icon class="mr-1">add</v-icon> Button with Icon</v-btn></div>
                  </div>
                  </v-flex>
                    <v-flex xs6>
                  <div class="bgdark btncontainer">
                    <div class="btndiv"><v-btn dark flat outline>Button</v-btn></div>
                    <div class="btndiv"><v-btn dark flat outline>Active</v-btn></div>
                    <div class="btndiv"><v-btn dark flat outline :disabled="disabled">Disabled</v-btn></div>
                    <div class="btndiv"><v-btn dark flat outline><v-progress-circular v-if="loading" indeterminate size="22" width="3"></v-progress-circular></v-btn></div>
                    <div class="btndiv"><v-btn dark flat outline><v-icon class="mr-1">add</v-icon> Button with Icon</v-btn></div>
                  </div>
                  </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs3 class="mb-5 mr-2">
                  <h2>Text Button</h2>

                  <div class="bglight btncontainer">
                    <div class="btndiv"><v-btn flat text>Text Button</v-btn></div>
                    <div class="btndiv"><v-btn flat text>Active</v-btn></div>
                    <div class="btndiv"><v-btn flat text :disabled="disabled">Disabled</v-btn></div>
                    <div class="btndiv"><v-btn flat text>Loading</v-btn></div>
                    <div class="btndiv"><v-btn flat text><v-icon class="mr-1">add</v-icon> Text Button with Icon</v-btn></div>
                  </div>
                </v-flex>

            </v-layout>
          </v-container>
        </v-flex>
    </v-layout>
</template>

<style scoped lang='scss'>
  @import "src/styles/variables.scss";

  .bgdark {
    background-color: #11395C;
  }
  .bglight {
    background-color: $white;
  }
  .btncontainer {
    // margin: 15px;
    padding: 15px;
  }
  .btndiv {

  }
</style>

<script>

export default {
  data() {
    return {
      loading: true,
      disabled: true
    }
  },
  methods: {}
}
</script>
